import React from 'react';
import Arrow from './Arrow';

function SignupButton(props) {
  return <a className={"plausible-event-name=SignupClicked hover:scale-105 transition-all duration-200 font-standard font-semibold px-5 text-black bg-white hover:bg-gray-200 align-middle ease btn " + (props.short ? " h-10 rounded-md" : " px-10")} href={process.env.REACT_APP_INSTALL_URL} target="blank_">Sign up <Arrow /></a>
}

export default SignupButton;
